import React from 'react';
import './Grupo.css';

import Jogador from './Jogador';
import validarTipo from '../utils/validarTipo';

export default class Grupo extends React.Component {
  render() {
    let i;
    const { acompanhamento = false, nome, jogadores, selecionarJogador, acaoAtiva, idTime } = this.props;
    // const qtdeDivisao = 4; // Qtde de jogadores por coluna
    const qtdeDivisao = Math.round(jogadores.length / 2);
    const jogadoresLeft = [];
    const jogadoresRight = [];
    for (i = 0; i < qtdeDivisao; i++) {
      if (jogadores[i]) {
        jogadoresLeft.push(
          <Jogador
            acompanhamento={acompanhamento}
            key={i.toString()}
            jogador={jogadores[i]}
            versao="Grupo"
            selecionarJogador={selecionarJogador}
            acaoAtiva={acaoAtiva}
            idTime={idTime}
          />,
        );
      }
      if (jogadores[i + qtdeDivisao]) {
        jogadoresRight.push(
          <Jogador
            acompanhamento={acompanhamento}
            key={i.toString()}
            jogador={jogadores[i + qtdeDivisao]}
            versao="Grupo"
            selecionarJogador={selecionarJogador}
            acaoAtiva={acaoAtiva}
            idTime={idTime}
          />,
        );
      }
    }

    const nomes = () => {
      if (validarTipo(nome, 'string')) {
        const nomeEditado = `${parseInt(nome, 10)}`;
        return nomeEditado;
      }
      if (validarTipo(nome, 'object')) {
        if (nome.length === 1) {
          return `GRUPO ${parseInt(nome[0], 10)}`;
        } else {
          let str = '';
          for (let i = 0; i < nome.length; i++) {
            if (i === nome.length - 1) {
              str += `${parseInt(nome[i], 10)}`;
              // str += ` e ${nome[i].toString()}`; // Versão horizontal
            } else if (i === nome.length - 2) {
              str += `${parseInt(nome[i], 10)}`;
            } else {
              str += `${parseInt(nome[i], 10)}`;
              // str += `${nome[i].toString()}, `; // Versão horizontal
            }
          }
          return `GRUPOS ${str}`;
        }
      }
    };

    const formatarNome = nome => {
      const nomeFormatado = nome.split('').map((letra, index) => {
        if (index < nome.length - 1) {
          return (
            <React.Fragment key={`${letra}${index}`}>
              {letra}
              <br />
            </React.Fragment>
          );
        } else {
          return <React.Fragment key={`${letra}${index}`}>{letra}</React.Fragment>;
        }
      });
      return nomeFormatado;
    };

    return (
      <div className="Grupo">
        <div className="GrupoContainer">
          <div className="GrupoHeader">
            <p>{formatarNome(nomes())}</p>
          </div>
          <div className="GrupoBody">
            <div className="Jogadores">{jogadoresLeft}</div>
            <div className="Jogadores">{jogadoresRight}</div>
          </div>
        </div>
      </div>
    );
  }
}
